import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M120-250.001q-29.154 0-49.576-20.423Q50-290.846 50-320t20.423-49.576Q90.846-389.999 120-389.999q6.769 0 12.231.577t10.846 3.731l191.232-191.232q-3.154-5.384-3.731-10.846T330.001-600q0-29.154 20.423-49.576 20.422-20.423 49.576-20.423t49.576 20.423q20.423 20.422 20.423 49.576 0 3.539-3.538 22.308l111.231 111.231q5.385-2.384 10.462-2.961t11.846-.577q6.769 0 12.039.577 5.269.577 10.269 3.731l152.001-152.001q-3.154-5-3.731-10.269-.577-5.27-.577-12.039 0-29.154 20.423-49.576 20.422-20.423 49.576-20.423t49.576 20.423q20.423 20.422 20.423 49.576t-20.423 49.576Q869.154-570.001 840-570.001q-6.769 0-12.039-.577-5.269-.577-10.269-3.731L665.691-422.308q3.154 5 3.731 10.269.577 5.27.577 12.039 0 29.154-20.423 49.576-20.422 20.423-49.576 20.423t-49.576-20.423Q530.001-370.846 530.001-400q0-6.769.577-12.231t3.731-10.846L423.077-534.309q-5.384 3.154-10.846 3.731t-12.231.577q-3.539 0-22.308-3.538L186.461-342.308q2.384 5.385 2.961 10.462t.577 11.846q0 29.154-20.423 49.576-20.422 20.423-49.576 20.423z"
      ></path>
    </svg>
  );
}

export default Icon;
